"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.CONTENT_TYPE="application/json",exports.CONTENT_TYPE_HEADER="Content-Type";
//# sourceMappingURL=axios-helper.constants.js.map
